import { Routes } from '@angular/router';

export const pagesRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/pages/pages.component').then(c => c.PagesComponent),
    data: { pageTitle: 'PAGES.PAGES.TITLE', pageType: 'list' }
  },
  {
    path: 'add',
    loadComponent: () => import('./pages/add-edit-page/add-edit-page.component').then(c => c.AddEditPageComponent),
    data: { pageTitle: 'PAGES.PAGES.ADD', pageType: 'add' }
  },
  {
    path: 'edit/:id',
    loadComponent: () => import('./pages/add-edit-page/add-edit-page.component').then(c => c.AddEditPageComponent),
    data: { pageTitle: 'PAGES.PAGES.EDIT', pageType: 'edit' }
  } 
];
